import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MenuButtonsHeaderComponent} from '../../shared/components/menu-buttons-header/menu-buttons-header.component';
import {SquareButtonComponent} from '../../shared/components/square-button/square-button.component';
import {MrzCameraComponent} from '../mrz-ocr/mrz-camera.component';
import {MrzFieldsService} from '../../core/services/mrz-fields.service';
import {Router} from '@angular/router';
import {ModalErrorService} from '../../core/services/modal-error.service';
import {MetricsService} from '../../core/services/metrics.service';
import {ModalInfoService} from '../../core/services/modal-info.service';

@Component({
  selector: 'check-in-mrz',
  templateUrl: './check-in-mrz.component.html',
  styleUrls: ['./check-in-mrz.component.scss'],
  imports: [
    CommonModule,
    MenuButtonsHeaderComponent,
    SquareButtonComponent,
    MrzCameraComponent
  ],
})
export class CheckInMrzComponent {

  busy = false;
  captureCounts = 0;

  currentStep: 'intro' | 'scanner' = 'intro';

  mrzFields: any = null;

  constructor(
    private router: Router,
    private mrzState: MrzFieldsService,
    private modalErrorService: ModalErrorService,
    private metricsService: MetricsService,
    private modalInfoService: ModalInfoService,
  ) {
    this.currentStep = 'intro';
  }


  onMrzSuccess(fields: any): void {
    console.log('MRZ fields:', fields);
    this.metricsService.mrzSuccess();
    this.mrzFields = fields;
    this.mrzState.set(fields);
    this.mrzState.setSuccess(true);
    this.router.navigate(['/check-in-adult']);
  }

  onMrzPartialSuccess(fields: any): void {
    console.log('MRZ fields with partial data:', fields);
    this.metricsService.mrzPartialSuccess();
    this.mrzFields = fields;
    this.mrzState.set(fields);
    this.router.navigate(['/check-in-adult']);
  }

  onMrzError(message: string): void {
    console.error('Error capturando MRZ:', message);
    this.busy = false;
    if (this.captureCounts >= 2) {
      this.router.navigate(['/check-in-adult']).finally(
        () =>
        this.modalErrorService.enqueue(
          'Error de lectura',
          [
            'No ha sido posible extraer los datos de tu documento de identidad o pasaporte.',
            'Por favor, rellena todos tus datos en el formulario.',
            'Estos serán enviados a los Cuerpos de Seguridad del Estado para cumplir con la Normativa de Viajeros.',
            {text: 'Todos los campos son obligatorios y serán validados por tu anfitrión.', bold: true}
          ])
      )
    } else {
      this.modalErrorService.enqueue(
        'Error de lectura',
        ['Encuadra la banda MRZ dentro del recuadro, sin cortarla.',
          'Coloca tu documento de identidad o pasaporte en un lugar bien iluminado y asegúrate de que no haya brillos ni sombras sobre el texto.'
        ]
      )
    }
  }

  onMrzCapture(): void {
    this.metricsService.mrzCapture();
    console.log('Capturando MRZ...');
    this.busy = true;
    this.captureCounts += 1;
  }

  goToScanner(): void {
    this.metricsService.mrzStarted();
    this.currentStep = 'scanner';
  }

  protected skipScanner() {
    this.metricsService.mrzSkipped();
    this.router.navigate(['/check-in-adult']).finally(
      () => {
        this.modalInfoService.enqueue(
          'Lectura de MRZ omitida',
          [
            'Por favor, rellena todos tus datos en el formulario.',
            'Estos serán enviados a los Cuerpos de Seguridad del Estado para cumplir con la Normativa de Viajeros.',
            {text: 'Todos los campos son obligatorios y serán validados por tu anfitrión.', bold: true}
          ])
      }
    )
  }
}
